import React, { useState } from "react";
import { useCsrfToken } from "../../hooks/useCsrfToken";
import { baseAxios } from "../../apis";
import { useToast } from "../../context/toastContext";
import { extractErrorMessage } from "../../utils";
import useAuthedApi from "../../hooks/useAuthedApi";
import DialogSuccess from "../dialogs/DialogSuccess";

export const FeedbackSection = () => {
  const { authedPost } = useAuthedApi();
  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false); // ← tambah ini
  const { addToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!feedback.trim()) {
      addToast("error", "Feedback cannot be empty.", 5000);
      return;
    }

    setLoading(true);
    try {
      await authedPost("/api/suggestion", {
        message: feedback,
      });

      setFeedback("");
      setShowSuccessDialog(true); // ← show dialog, hapus addToast success
    } catch (error) {
      console.error("Failed to submit feedback:", error);
      const errorMessage = extractErrorMessage(error?.response?.data || error);
      addToast("error", errorMessage, 10000);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <>
      {/* ← tambah DialogSuccess di sini */}
      <DialogSuccess
        open={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        status="success"
        title="Thank you! Your feedback has been submitted. We'll review it and use it to improve your experience."
      />

      <div className="flex flex-col justify-center w-full lg:w-1/2 bg-white rounded-xl p-4">
        <h2 className="text-xl font-bold text-gray-900 mb-3">
          Tell us what you want to see in the dashboard
        </h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <input
              type="text"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Enter your suggestion here"
              aria-label="Feedback input"
              className="flex-1 px-4 py-2 rounded-md border border-gray-200 bg-gray-50 text-sm placeholder-gray-400 shadow-sm ring-1 ring-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              disabled={loading}
              type="submit"
              className="px-5 py-2 rounded-md bg-[#007A78] hover:bg-[#004746] text-white text-sm font-medium"
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
